import {
  extractSiteIdFromSearch,
  getCurrentSearchString,
} from 'utils/routing/urlHelpers'

export const resolvePlayerSiteId = ({
  currentSite,
  siteId,
  userContext,
  locationSearch,
} = {}) => {
  const explicitSiteId = siteId ?? currentSite?.siteId
  if (explicitSiteId != null) return explicitSiteId

  const siteIdFromUrl = extractSiteIdFromSearch(
    locationSearch ?? getCurrentSearchString(),
  )
  if (siteIdFromUrl != null) return siteIdFromUrl

  return userContext?.sites?.[0]?.siteId
}
